import React from "react";
import Grid from "@material-ui/core/Grid";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from "prop-types";

const BilateralGuaranteeInAccountView = (props) => {
    return (
        <div className={props.cssStyle}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SubtitleLabel header={props.subtitle ?? 'Garantías en cuenta'} isBold={true}/>
                </Grid>
                <Grid item xs={12}>
                    <DataTable
                        value={props.guaranteeList}
                        footerColumnGroup={props.footerColumnGroup}
                        resizableColumns={true}
                        columnResizeMode={"fit"}
                        scrollable={true}
                        scrollHeight="400px" >
                        <Column
                            field="composeName"
                            header="Emisora"
                            filter={true}
                            style={{textAlign: 'left'}}
                            sortable={true}/>
                        <Column
                            field="haircut"
                            header="% Aforo"
                            body={props.styleInstrumentCapacityTemplate}
                            style={{textAlign: 'right'}}
                            sortable={true}/>
                        <Column
                            field="discountedPrice"
                            header="Precio Desc."
                            style={{textAlign: 'right'}}
                            body={props.styleInstrumentPriceTemplate}
                            sortable={true}/>
                        <Column
                            field="price24Hours"
                            header="Precio Mercado"
                            style={{textAlign: 'right'}}
                            body={props.styleInstrumentPriceTemplate}
                            sortable={true}/>
                        <Column
                            field="suggested"
                            header="Sugerido"
                            body={props.styleInstrumentNumberTemplate}
                            style={{textAlign: 'right'}}
                            sortable={true}/>
                        <Column
                            field="newTitles"
                            header="Títulos"
                            editor={props.numberEditor}
                            body={props.styleInstrumentNumberTemplate}
                            style={{textAlign: 'right'}}
                            sortable={true}/>
                        <Column
                            field="guaranteedAmount"
                            header="Importe Garantizado"
                            body={props.styleInstrumentAmountTemplate}
                            style={{textAlign: 'right'}}
                            sortable={true}/>
                        <Column
                            field="marketAmount"
                            header="Importe Mercado"
                            body={props.styleInstrumentAmountTemplate}
                            style={{textAlign: 'right'}}
                            sortable={true}/>
                    </DataTable>
                </Grid>
            </Grid>
        </div>
    )
};

export default BilateralGuaranteeInAccountView;

BilateralGuaranteeInAccountView.propTypes = {
    cssStyle: PropTypes.string.isRequired,
    guaranteeList: PropTypes.array.isRequired,
    footerColumnGroup: PropTypes.object.isRequired,
    numberEditor: PropTypes.object.isRequired,
    styleInstrumentCapacityTemplate: PropTypes.object.isRequired,
    styleInstrumentPriceTemplate: PropTypes.object.isRequired,
    styleInstrumentNumberTemplate: PropTypes.object.isRequired,
    styleInstrumentAmountTemplate: PropTypes.object.isRequired,
    subtitle: PropTypes.string,
};